import styled from 'styled-components'
// utils
import { ellipsis } from 'polished'

export const EllipsizedText = styled.span`
  ${ellipsis('100%')};
`
